import ContactForm from "../ContactForm";
import {
    MainContent,
    HeaderWrapper,
    ContentContainer,
    HeaderContainer,
    Title
} from "../StyledComponents";

function Contact() {
    return (
        <MainContent>
            <HeaderContainer>
                <HeaderWrapper>
                    <Title>Kontakt</Title>
                </HeaderWrapper>
            </HeaderContainer>
            <ContentContainer>
                <ContactForm selection="contact" />
            </ContentContainer>

        </MainContent>
    )
}

export default Contact;